import { render, staticRenderFns } from "./HistoryOrderMovementToggle.vue?vue&type=template&id=209b0d56&scoped=true"
import script from "./HistoryOrderMovementToggle.vue?vue&type=script&lang=js"
export * from "./HistoryOrderMovementToggle.vue?vue&type=script&lang=js"
import style0 from "./HistoryOrderMovementToggle.vue?vue&type=style&index=0&id=209b0d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b0d56",
  null
  
)

export default component.exports